/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missmatch_DefectInputs */



/**
* | output |
* | --- |
* | "Mismatch fault" |
*
* @param {Missmatch_DefectInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const missmatch_defect = /** @type {((inputs?: Missmatch_DefectInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missmatch_DefectInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mismatch fault")
	return /** @type {LocalizedString} */ ("Défaut de discordance")
});